import React from 'react';
import { StyledLabel } from '../../../assets/styledComponents/Global';
import PortletHeaderTabs from './PortletHeaderTabs';
import { useTheme } from 'styled-components';
// import ArrowButtonIcon from '../svgIcons/ArrowButtonIcon';
import ArrowIcon from '../svgIcons/ArrowIcon';

const PortletHeader = ({
  title = '',
  headerClassName = '',
  containerClassName = '',
  actions,
  subTitle,
  borderBottom,
  tabs,
  titleDetails,
  filters,
  onChangeTabs,
  breadCrumb,
  counts,
  count,
  tag,
  id,
  labelClassName = '',
  wizard,
  wizardTemp,
  search,
  backLink
}) => {
  const theme = useTheme();

  return (
    <div
      className={`portlet__header-container rounded ${wizard ? '_1-step' : ''} ${!tabs ? 'isHeadingOnly' : ''
        } ${containerClassName}`}
    >
      {counts && <div className="mb-1">{counts}</div>}

      <div className="flex-center flex-wrap">
        {backLink && <ArrowIcon rotate='left' className='me-2 cursor-pointer' onClick={() => (window.location.href = backLink)} color={theme?.primary} />}
        {title && (
          <h2 className="flex-grow-1 m-0 fw-normal">
            <span className={`${tag && 'd-flex align-items-center'} `}>
              <span className='portlet-header-title text-primary '>
                {title ?? ''}
              </span>
              {tag && <span>{tag}</span>}
            </span>
            {subTitle && <span className="fw-normal fs-4 portlet-header-subtitle text-primary text-secondary">{subTitle}</span>}
            {count && <span className='text-primary'>{' ' + count}</span>}
          </h2>
        )}
        {breadCrumb && <div className="flex-grow-1 ">{breadCrumb}</div>}
        {actions && <div>{actions}</div>}
      </div>

      {titleDetails && (
        <StyledLabel
          size="14px"
          weight="500"
          color={theme.borderColor}
          className={labelClassName}
        >
          {titleDetails}
        </StyledLabel>
      )}

      <div
        className={
          breadCrumb ? 'd-flex justify-content-center ' : 'flex-center flex-wrap'
        }
      >
        <div className={breadCrumb ? '' : 'flex-grow-1'}>
          {tabs && (
            <div
              className={`portlet__header pb-0 ${headerClassName} ${borderBottom ? 'portlet__header-border' : ''
                }`}
            >
              <div className={breadCrumb ? '' : 'flex-grow-1'}>
                {tabs && (
                  <PortletHeaderTabs tabs={tabs} onChangeTabs={onChangeTabs} title={title} wizardTemp={wizardTemp} />
                )}
              </div>
            </div>
          )}
        </div>
        <div className="display-flex">{filters && <div>{filters}</div>}</div>
      </div>
      <div >{search && <div>{search}</div>}</div>

    </div>
  )
};

export default PortletHeader;
